import * as Yup from "yup";
import {RubricItem, NewPlanRubricForm} from "../../../../../types/newPlanItem";
import {t} from "i18next";

export const initialRubricItem: RubricItem = {
    id: null,
    productCode: "",
    productName: "",
    productBrief: "",
    price: "",
    unit: null,
    amount: ""
}

export const initialValues: NewPlanRubricForm = {
    productType: {value: "", label: ""},
    item: initialRubricItem,
};

export function ValidationSchema() {
    return Yup.object({
        productType: Yup.object({
            value: Yup.string().required(t("validation.required")),
        }),
        item: Yup.object({
            id: Yup.number().nullable(),
            productCode: Yup.string().required(t("validation.required")),
            productName: Yup.string().required(t("validation.required")),
            productBrief: Yup.string()
                .nullable()
                .required(t("validation.required")),
            unit: Yup.object({
                id: Yup.number().nullable(),
                label: Yup.string().nullable(),
            })
                .required(t("validation.required"))
                .typeError(t("validation.required")),
            amount: Yup.string()
                .typeError('Quantity должен быть числом')
                .required(t("validation.required")),
            price: Yup.string()
                .typeError('Price должен быть числом')
                .required(t("validation.required")),
        }).required(),
    });
}